import React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { DoneRounded } from '@mui/icons-material';

import "Common.css";
import "./PricingEngineVisitList.css";

import BaseElem from "BaseElem";
import {
  formatDate,
  dateToAMPM,
  parseDate,
  getDurationString,
  areDatesSame,
  convertToDestTZ,
} from "Util/DateUtils";
import { Procedure } from "../../@types/PricingModels";

type PricingEngineListProps = {
  recipientStore?: any;
  visitDraftStore?: any;

  allServices?: any;
  match: any;
  pricedVisitIds?: any[];
  region?: string;
  // firstVisit?: any;
  visits?: any[];
  // requestDateTime?: Date;
};

type PricingEngineListConnectProps = {};

type PricingEngineListState = {
  selectedIds: any;
};

type PricingEngineListActualProps = PricingEngineListProps &
  PricingEngineListConnectProps &
  RouteComponentProps<any>;

class PricingEngineList extends BaseElem<
  PricingEngineListActualProps,
  PricingEngineListState
> {
  constructor(props: PricingEngineListActualProps) {
    super(props);
    this.state = {
      selectedIds: (props.visits || []).map((visit: any) => visit._id),
    };
  }

  componentDidMount() {
    //const self = this;
    //self.generatePricingForSelected(self.props.requestDateTime);
    // self.listen(MSG_PRICING_RESET);
  }

  componentWillUnmount() {
    // this.unlisten(MSG_PRICING_RESET);
  }

  /*onMessage(messageName: string, payload?: any) {
    switch (messageName) {
      case MSG_PRICING_RESET:
        this.setState({ selectedIds: [] });
        break;
    }
  }*/

  // Toggle visit selection on click
  _toggleSelection(draftId: string) {
    let selectedIds = this.state.selectedIds;
    if (selectedIds.includes(draftId)) {
      selectedIds = selectedIds.filter((_id: string) => _id !== draftId);
    } else {
      selectedIds.push(draftId);
    }
    this.setState({ selectedIds });
  }

  /*generatePricingForSelected(requestDateTime: Date | undefined) {
    const self = this,
      props = self.props;
    const pricedVisitIds = props.pricedVisitIds || [];
    const selectedIds = self.state.selectedIds;

    const selectedVisits = (props.visits || []).filter(
      (v: any) => !pricedVisitIds.includes(v._id) && selectedIds.includes(v._id)
    );
    const selectedVisitIds = selectedVisits.map((v: any) => v._id);

    props.generatePricing(
      selectedVisits,
      selectedVisitIds,
      props.match.params.id,
      requestDateTime
    );
  }*/

  _getTags(draft: any) {
    const self = this,
      props = self.props;
    const tags: any = [];

    const pushTag = (ifTrue: boolean, text: string) => {
      ifTrue &&
        tags.push(
          <p className="pel-visit-tags" key={`${draft._id}_${text}`}>
            {text}
          </p>
        );
    };

    pushTag(!!(draft.requested_services || [])[0], "ADL");

    if (draft.nursing_procedure && draft.nursing_procedure.length > 0) {
      const allServices = props.allServices;

      const allSimpleProcedures = allServices && allServices.simple_procedures;
      const allComplexProcedures =
        allServices && allServices.complex_procedures;
      const procedureNameArray = draft.nursing_procedure.map(
        (procedure: any) => procedure.name
      );
      const hasSimple = allSimpleProcedures.some((prod: Procedure) =>
        procedureNameArray.includes(prod.name)
      );
      const hasComplex = allComplexProcedures.some((prod: Procedure) =>
        procedureNameArray.includes(prod.name)
      );
      pushTag(hasSimple, "SN");
      pushTag(hasComplex, "CN");
    }
    pushTag(!!(draft.home_rehabilitation || [])[0], "HT");
    pushTag(!!(draft.home_medical || [])[0], "HM");
    return tags;
  }

  renderVisit = (draft: any, index: number) => {
    const isUpdating = draft?.visit_status;
    const self = this,
      selectedIds = self.state.selectedIds;
    const startDate = isUpdating
      ? convertToDestTZ(
        parseDate(draft.visit_schedule.date_from),
        this.props.region
      ) ?? new Date()
      : parseDate(draft.visit_schedule.date_from);
    const endDate = isUpdating
      ? convertToDestTZ(
        parseDate(draft.visit_schedule.date_to),
        this.props.region
      ) ?? new Date()
      : parseDate(draft.visit_schedule.date_to);
    const plusOne = areDatesSame(startDate, endDate) ? "" : " +1";
    const id = draft._id;
    const isSelected = selectedIds.includes(id);

    return (
      <div
        className={"pricing-list-item" + (isSelected ? " selected" : "")}
        key={id}
      // onClick={() => self._toggleSelection(id)}
      >
        <div className="pel-index">{index + 1}</div>
        <div className="pricing-item-datetime">
          <div className="pricing-item-bold">
            <b>{formatDate(startDate)}</b>
          </div>
          <p className="pricing-item-bold">{`${dateToAMPM(
            startDate
          )} - ${dateToAMPM(endDate)} ${plusOne}`}</p>
          <div className="horizontal pel-tags">
            <p className="pel-visit-tags">
              {getDurationString(startDate, endDate, true).toUpperCase()}
            </p>
            {self._getTags(draft)}
          </div>
        </div>
        {isSelected && <DoneRounded className="pel-pricing-icon" fontSize="inherit" />}
      </div>
    );
  };

  render() {
    const self = this,
      props = self.props,
      visits = props.visits;
    if (!visits) return <div />;

    //const selectedIds = self.state.selectedIds;
    const pricedVisitIds = props.pricedVisitIds || [];

    const visitsNotPriced = visits.filter(
      (v: any) => !pricedVisitIds.includes(v._id)
    );

    let renderedVisits = null;
    if (visitsNotPriced[0]) {
      renderedVisits = visitsNotPriced.map((draft: any, index: number) =>
        self.renderVisit(draft, index)
      );
    } else {
      renderedVisits = (
        <div className="empty-list-item">All visits are priced</div>
      );
    }

    // const selectedMinusPriced = selectedIds.filter(
    //   (id: string) => !pricedVisitIds.includes(id)
    // );
    return (
      <div className="pricing-list-container vertical">
        <h3 className="plc-heading">Selected Visit(s)</h3>
        {renderedVisits}
        {/* <Button
          className="ha-btn-green pel-generate-pricing"
          disabled={!selectedMinusPriced.length}
          onClick={()=> self.generatePricingForSelected(props.requestDateTime)}
        >
          Generate Pricing
        </Button> */}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { visitDraftStore, pricingStore } = state;
  const { services, available_procedures, therapy } = visitDraftStore;
  const { simple_nursing_procedures, complex_nursing_procedures } =
    available_procedures;

  const allServices = {
    services,
    simple_procedures: simple_nursing_procedures,
    complex_procedures: complex_nursing_procedures,
    therapy,
  };

  return {
    ...state,
    allServices,
    pricedVisitIds: pricingStore.appliedPricingIds,
  };
};

const mapDispatchToProps = (_dispatch: any) => ({});

export default withRouter(
  connect<PricingEngineListState, PricingEngineListConnectProps>(
    mapStateToProps,
    mapDispatchToProps
  )(PricingEngineList)
);
